import { HOME } from "../routes"

const Footer = () => {
  return (
    <footer className="px-4 py-2 bg-white w-full bottom-0 shadow flex flex-col md:flex-row items-center justify-between fixed">
      <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
        © 2025{" "}
        <a href={HOME} className="hover:underline">
          RoofTop SolarOps
        </a>
        . All Rights Reserved.
      </span>
      <ul className="flex flex-wrap items-center mt-3 text-sm text-gray-500 dark:text-gray-400 sm:mt-0">
        <li>
          <a href={HOME} className="mr-4 hover:underline md:mr-6">
            About
          </a>
        </li>
        <li>
          <a href={HOME} className="mr-4 hover:underline md:mr-6">
            Privacy Policy
          </a>
        </li>
        <li>
          <a href={HOME} className="hover:underline">
            Contact
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
